import validate from "/app/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@22.7.4_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_nhq22ea2h6es77xgdwmliv67re/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@22.7.4_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_nhq22ea2h6es77xgdwmliv67re/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}